import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import SetupGuide from 'cio/models/setup-guide';
import { PresentationLocation } from 'cio/utils/setup-guide/messaging-channels';
import EnvironmentService from 'cio/services/environment';

export default class SetupGuideChannelsTwilioController extends Controller {
  @service environment!: EnvironmentService;

  model!: SetupGuide;

  presentationLocation = PresentationLocation;
}
